// Backlog #672 (2026-11-03): two app-wide axios defaults, installed once from index.js.
//
// 1) Query parameters are percent-encoded completely. axios's own encoder leaves [ and ] as they are,
//    and Tomcat (the Java gateway) answers 400 to a raw [ or ] in a query string -- on the preflight
//    OPTIONS already, so the browser only reports a "Network Error". Free text in params (a change-request
//    note, the company search "[PT] ...", a rejection reason) therefore failed whenever it held a bracket.
//    encodeURIComponent turns them into %5B / %5D, which the backend decodes back to the exact text.
// 2) A failure with no response at all (no network, CORS / preflight refused, server down) reads in the
//    UI language. axios's message for it is the raw English "Network Error", and the screens show
//    error.message as it is.
import axios from "axios";
import i18n from "./i18n";

axios.defaults.paramsSerializer = { ...(axios.defaults.paramsSerializer || {}), encode: encodeURIComponent };

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && !error.response && error.code === "ERR_NETWORK") {
      error.message = i18n.t("common:agHatasi");
    }
    return Promise.reject(error);
  }
);
